module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNi8yNC8xMn+6RgAAAAAYdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3Jrc0+zH04AAAAUSURBVAiZY/z//z8DOmDCEKFcEAA2UAMHjYSsRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/components/revolution_slider/assets/coloredbg.png
// module id = ../../../../../src/assets/components/revolution_slider/assets/coloredbg.png
// module chunks = 2